import useWaitingParticipantAlert from 'flow/hooks/useWaitingParticipantAlert';

/**
 * Sounds the waiting-room alert (VID-76) for as long as the app is running,
 * rather than for as long as the meeting is on screen: someone knocking has to
 * be heard while the meeting sits in the dock, or behind whatever else the user
 * is doing, which is exactly when a sound is the only thing that will reach
 * them.
 *
 * Renders nothing, and exists only so the subscription behind it sits on a leaf
 * — a knock would otherwise re-render the whole app shell to play a sound.
 *
 * Mounted in Main outside its isMobileApp guard, since the alert has no chrome
 * to belong to and a knock should be heard on mobile too.
 */
const MeetingWaitingRoomAlert = (): null => {
    useWaitingParticipantAlert();

    return null;
};

export default MeetingWaitingRoomAlert;
